<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive" class="router-view" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" class="router-view" /> -->
      <router-view class="router-view" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      preImg: [
          require('@/assets/common/common_bg_top3@2x.png'),
        ]
    }
  },
  created() {
    // console.log("app created")
    this.init();
    this.getLang();
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    }
  },
  methods: {
    init(max_width = 480) {
      // (function (doc, win) {
      let doc = document;
      let win = window;
      let docEl = doc.documentElement;
      let resizeEvt =
        "orientationchange" in window ? "orientationchange" : "resize";
      let recalc = function() {
        let clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        clientWidth = clientWidth > max_width ? max_width : clientWidth;
        docEl.style.fontSize = parseInt(clientWidth / 7.5) + "px";
      };
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
      // })(document, window);
    },
    preload() {
        if (document.images) {
          // console.log("preload")
          let images = new Array();
          for (let i = 0, length = this.preImg.length; i < length; i++) {
            let img = new Image();
            img.src = this.preImg[i];
            images.push(img)
          }
          // console.log(images)
          // console.log("preload end")
        }
    },
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    getLang() {
      // console.log('this.$route.query.lang',this.getUrlKey('lang'))
      if(this.getUrlKey('lang')) {
        let lang = this.getUrlKey('lang')
        if(lang!='zh_CN') {
          lang = 'zh_TW'

        } 
        localStorage.setItem('locale',lang)
        this.$i18n.locale = lang
      }
    },
  }
};
</script>

<style lang="css">
#app::before {
    position: fixed;
    z-index: -1;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f0f0f0;
  }
 button.van-dialog__confirm,  button.van-dialog__confirm:active {
   color:#F6323E;
}
.van-pull-refresh__track {
  min-height: 450px;
}
/* 页面动画 */
   .slide-enter-active, .slide-leave-active {
     transition: all 0.3s
   }
    
  .slide-enter, .slide-leave-to {
    transform: translate3d(100%, 0, 0)
  }

  .move-enter-active, .move-leave-active {
    transition: all 0.2s linear;
      transform: translate3d(0, 0, 0);
  }
      
  .move-enter, .move-leave {
      transform: translate3d(100%, 0, 0)
  }

  .top-enter-active {
    transition: all 0.2s linear;
      transform: translateY(0);
  }
  .top-leave-active {
    transition: all 0.2s linear;
      transform: translateY(100%);
  }
  .top-enter {
      transform: translateY(100%)
  }
  .top-leave {
      transform: translateY(0)
  }
  .router-fade-enter-active, .router-fade-leave-active {
	  	transition: opacity .3s;
	}
	.router-fade-enter, .router-fade-leave-active {
	  	opacity: 0;
	}
  .loading-enter-active, .loading-leave-active {
      transition: opacity .7s
  }
  .loading-enter, .loading-leave-active {
      opacity: 0
  }
  .bar-fade-enter-active,.bar-fade-leave-active {
	  	transition: opacity 2s;
	}
	.barr-fade-enter, .bar-fade-leave-active{
	  	opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue